import { useProfile } from './useProfile';

export const useTimezone = (): string => {
  const profile = useProfile();
  return profile?.timezone || 'UTC';
};

